import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Drawer,message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select ,Modal } from 'antd';
import $ from 'jquery';

import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import person from '../../assets/images/icon/person.png';
import correct from '../../assets/images/icon/correct.png';
import wrong from '../../assets/images/icon/wrong.png';
import edit from '../../assets/images/icon/edit.png';


const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;


function callback(key) {
  console.log(key);
}

const format = 'HH:mm a' ;


class Index extends React.Component {
	static contextTypes = {
			router: () => null
		};
	constructor(props) {
		
		super(props);
		this.state = {
			size: 'default',
			
			value: '',
			children_id: [],
			staff_id: [],
			type: '',
			days: '',
			user_id: '',
			age_from_year: '',
			age_from_month: '',
			age_to_year: '',
			age_to_month: '',
			timing_from: '',
			onChange_timing_to: '',
			timing_to: '',
			child: false,
			staff: false,
			loading: false,
			Program: false,
  		    iconLoading: false,
  		    school_list:[],
  		    school_list_:[],
			selected_student: [],
			selected_student_data: [],
			selected_program: [],
			selected_program_1: [],
			program_list: [],
  		    program_id: [],
			mobile_child: false ,
			mobile_class: false ,
			master_id: [],		
			reports_master_list: [],		
			reports_data: [],
			dchecked: false,
			checked: false,
			checkedBoxes: [],
			dcheckedBoxes: [],	
		}
		this.handleSizeChange = this.handleSizeChange.bind(this);	
		this.changetype = this.changetype.bind(this);	
		this.change_age_from_month = this.change_age_from_month.bind(this);	
		this.change_age_from_year = this.change_age_from_year.bind(this);	
		this.change_age_to_year = this.change_age_to_year.bind(this);	
		this.change_age_to_month = this.change_age_to_month.bind(this);	
		
		this.onChange_timing_from = this.onChange_timing_from.bind(this);	
		this.onChange_timing_to = this.onChange_timing_to.bind(this);	
		this.handleSubmit = this.handleSubmit.bind(this);	
		this.goBack = this.goBack.bind(this);	
		
		this.onChangecheckedday = this.onChangecheckedday.bind(this);	
		this.handleClick = this.handleClick.bind(this);
		this.handleClickProgram = this.handleClickProgram.bind(this);
		this.onChangechecked = this.onChangechecked.bind(this);
	}
	
	showDrawer = () => {
		this.setState({
		  mobile_child: true,
		});
	  };
	 
	onClose = () => {
		this.setState({
		  mobile_child: false,
		});
	  }; 
	
	showDrawerClass = () => {
		this.setState({
		  mobile_class: true,
		});
	  };
	 
	onCloseClass = () => {
		this.setState({
		  mobile_class: false,
		});
	  }; 	


	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],program_id : this.props.match.params.id, });
		
		}
		
		this.checkData();
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			let program_id = this.props.match.params.id;
			var app = {user_id : user_id,program_id:program_id,school_id:school_id}
			getData('erp/program_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							name: result['data'][0]['name'],
							fee: result['data'][0]['fee'],
							type: result['data'][0]['fee_type'],
							days: result['data'][0]['days'],
							age_from_year: result['data'][0]['age_from_year'],
							age_from_month: result['data'][0]['age_from_month'],
							age_to_year: result['data'][0]['age_to_year'],
							age_to_month: result['data'][0]['age_to_month'],
							timing_from: result['data'][0]['timing_from'],
							timing_to: result['data'][0]['timing_to'],
							staff: result['data'][0]['staff'],
							children: result['data'][0]['children'],
							selected_student: result['data'][0]['children'],
							selected_program_1: result['data'][0]['staff'],
						});
						document.getElementById("name").value = result['data'][0]['name'];
						document.getElementById("fee").value = result['data'][0]['fee'];
						this.get_selected_student();
						this.get_selected_program();
						
						var per = result['data'][0]['days']
						const lenght_ = per.length;
						
						for (var i = 0; i < lenght_; i++) {
							var check = result['data'][0]['days'][i];
							document.getElementById(check).checked = true;
						}
						
					}else{
						this.setState({
							school_list: [],
							
						});
					}
				}
			});
			getData('erp/student_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list_: result['data'],
						});
					}else{
						this.setState({
							school_list_: [],
						});
					}
				}
			});
			getData('erp/view_staff',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							program_list: result['data'],
						});
					}else{
						this.setState({
							program_list: [],
						});
					}
				}
			});
			
			
			var app_ = {program_id : this.props.match.params.id,user_id : user_id,school_id:school_id,}
			getData('fees/get_student_reports_master',app_).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							reports_master_list: result['data'],
						});
					}else{
						this.setState({
							reports_master_list: [],
						});
					}
				}
			});	
			
			
		 //get data
			var app2 = {program_id : this.props.match.params.id,user_id : user_id,school_id:school_id}
			
			getData('fees/get_student_reports_master_details', app2).then((result) => {
				let responseJson = result;
				if (responseJson.data) {
					if (result['status'] == 200) {
						this.setState({
							reports_data: result['data'],
						});
						
						
						setTimeout(() => {
							var reports_data = this.state.reports_data;
										
							for (var i = 0; i < reports_data.length; i++) {
							    var  master_id=result['data'][i]['master_id']
							 	if(document.getElementById('question_'+master_id)){
									document.getElementById('question_'+master_id).checked=true;
								}
							}							 	
							
							
						 }, 500);
					} else {
						this.setState({
							reports_data: [],
						});
					}
				}
			}); 	
				
			
			
	}
  }
  
  showModal = () => {
		this.setState({
		  Program: true,
		});
	  };
  
  get_selected_student(){	
			if(this.state.selected_student.length==0){
				this.setState({
					selected_student_data: []
				});
			}	 
			var app2 = {user_id : this.state.selected_student,}
			getData('erp/student_list_selected',app2).then((result) => {
				let responseJson2 = result;
				if(responseJson2.data){
					if(result['status'] == 200){
						setTimeout(() => {
						this.setState({
							selected_student_data: result['data'],
						});	}, 500);	
						
					}else{
						setTimeout(() => {
						this.setState({
							selected_student_data: [],
						});	}, 500);	
					}
				}
			});	
			
	}
  
 showchildModal = () => {
    this.setState({
      child: true,
    });
  };

  handleOk = e => {
    this.get_selected_student();
    console.log(e);
    this.setState({
      child: false,
      staff: false,
      mobile_child: false,
    });
  };

  handleClick(event) {
        const target = event.target;
        var value = target.value;
		console.log(value);
        if(target.checked){
            this.state.selected_student[value] = value;   
            this.state.children_id[value] = value;   
        }else{
            this.state.selected_student.splice(value, 1);
            this.state.children_id.splice(value, 1);
        }
       console.log(this.state.selected_student);
		this.checkData();
    }
  

  handleCancel = e => {
    console.log(e);
    this.setState({
     child: false,
      staff: false,
    });
  };
  
  get_selected_program(){
			
			if(this.state.selected_program_1.length==0){
				this.setState({
					selected_program: []
				});
			}	
						
			var app2 = {user_id : this.state.selected_program_1,}
			getData('erp/selected_staff_list',app2).then((result) => {
				let responseJson2 = result;
				if(responseJson2.data){
					if(result['status'] == 200){
						this.setState({
							selected_program: result['data'],
						});
					}else{
						this.setState({
							selected_program: [],
						});
					}
				}
			});	
			
	}
	
	handleClickProgram(event) {
        const target = event.target;
        var value = target.value;
		console.log(value);

        if(target.checked){
            this.state.selected_program_1[value] = value;   
            this.state.staff_id[value] = value;   
        }else{
            this.state.selected_program = '';   
            this.state.staff_id = '';   
        }
       console.log(this.state.selected_program);
		this.checkData();
    }
	
	showModalProgram = () => {
    this.setState({
      Program: true,
    });
  };

	handleOkProgram = e => {
    this.get_selected_program();
    console.log(e);
    this.setState({
      Program: false,
      mobile_class: false,
    });
  };

  handleCancelProgram = e => {
    console.log(e);
    this.setState({
      Program: false,
    });
  };
  
  handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};
	
    onChangecheckedday(checkedValues) {
	  this.setState({ days: checkedValues });
	}
	
	onChangechecked(checkedValues) {
	
		var favorite = [];
        $.each($("input[name='days']:checked"), function(){
            favorite.push($(this).val());
        });
		
       // alert("My favourite sports are: " + favorite.join(", "));
	 this.setState({ days: favorite });
	}
	 
	changetype(event){
         this.setState({type: event});
     }
	 
	change_age_from_year(event){
         this.setState({age_from_year: event});
     }
	
	change_age_from_month(event){
         this.setState({age_from_month: event});
     }
	change_age_to_year(event){
         this.setState({age_to_year: event});
     }
	
	change_age_to_month(event){
         this.setState({age_to_month: event});
     }
	
	
	onChange_timing_from(time, timeString) {
	  this.setState({timing_from: timeString});
	}
	onChange_timing_to(time, timeString) {
	  this.setState({timing_to: timeString});
	}
	
	handleSubmit=(e)=>{
    e.preventDefault();
	if(localStorage.getItem('schoolData')){
    this.setState({ loading: true });
	
		 var storedArray = JSON.parse(localStorage.getItem("schoolData"))	
		
	       var master_id = [];
            $.each($("input[name='master_id']:checked"), function(){
                master_id.push($(this).val());
            });		
			
			var app = {	
		    	program_id :  this.props.match.params.id,
				school_id : storedArray['data'][0]['school_id'],
				user_id : storedArray['data'][0]['user_id'],			
				master_id : master_id,
				name : this.state.name,
				fee : this.state.fee,
				type : this.state.type,
				days : this.state.days,
				age_from_year : this.state.age_from_year,
				age_from_month : this.state.age_from_month,
				age_to_year : this.state.age_to_year,
				age_to_month : this.state.age_to_month,
				timing_from : this.state.timing_from,
				timing_to : this.state.timing_to,
				children_id : this.state.children_id,
				staff_id : this.state.staff_id,
			}
	
    
      getData('erp/edit_program',app).then((result) => {
      if(result.status==400){
            message.config({ top: 150});
			message.error('Please Insert All Field',2);
			this.setState({ loading: false });
          }
          if(result.status==200){
            message.config({ top: 150});
            message.success('Programs updated',2);
              this.setState({ loading: false });
              this.setState({comment_text:''});
              window.location.href = '/programs/index';
              //this.checkdata();

          }
      });
	  }else{
		message.error('Please Login',2);	
	  }

  }
	 goBack(){
		window.location.href = '/programs/index';
	}
	
	
	dtoggleChecked = () => {	
		const dcheckedBoxes = [...this.state.dcheckedBoxes];
		var checkboxes = document.getElementsByName('class_id[]');
		for (var i = 0; i < checkboxes.length; i++) {
			dcheckedBoxes.push(checkboxes[i].value);	
		}
		this.setState({staff_id:dcheckedBoxes,dcheckedBoxes,dchecked:true,dselection_count:dcheckedBoxes.length,selected_program_1:dcheckedBoxes,class_id:dcheckedBoxes});
    }
	 	
	dtoggleUnChecked = () => {	
		const dcheckedBoxes = [...this.state.dcheckedBoxes];
		this.setState({dcheckedBoxes:[],dchecked:false,dselection_count:0,selected_program_1:[],staff_id:[]});
    }
	
	
   dhandleCheckbox = (e, s) => {	
    const dcheckedBoxes = [...this.state.dcheckedBoxes];
    if(e.target.checked) {
		dcheckedBoxes.push(s)
    } else {
		const index = dcheckedBoxes.findIndex((ch) => ch === s);
		dcheckedBoxes.splice(index, 1);
    }
    this.setState({dcheckedBoxes,selection_count:dcheckedBoxes.length,selected_program_1:dcheckedBoxes,staff_id:dcheckedBoxes});
  }
  
  toggleChecked = () => {
		
		const checkedBoxes = [...this.state.checkedBoxes];
		var checkboxes = document.getElementsByName('checked_id[]');
		for (var i = 0; i < checkboxes.length; i++) {
			checkedBoxes.push(checkboxes[i].value);	
		}
		this.setState({checkedBoxes,checked:true,selection_count:checkedBoxes.length,selected_student:checkedBoxes,children_id:checkedBoxes});
		console.log(checkedBoxes);
    }
	

	
	toggleUnChecked = () => {	
		const checkedBoxes = [...this.state.checkedBoxes];
		this.setState({checkedBoxes:[],checked:false,selection_count:0,selected_student:[],children_id:[]});
    }
	
	
  
  handleCheckbox = (e, s) => {
	
    const checkedBoxes = [...this.state.checkedBoxes];
    if(e.target.checked) {
		checkedBoxes.push(s)
    } else {
		const index = checkedBoxes.findIndex((ch) => ch === s);
		checkedBoxes.splice(index, 1);
    }
    this.setState({checkedBoxes,selection_count:checkedBoxes.length,selected_student:checkedBoxes,children_id:checkedBoxes});
  }
	
	render()

	{
	
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img"><Tooltip placement="right" title="Audio"><img src={music} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Pdf"><img src={pdf_} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Image"><img src={image} class="" alt="image" /></Tooltip></p>
						
					  </div>
					);
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 
		 
		  <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     
					  <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Edit Program</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                       <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
						   
						   <li class="breadcrumb-item"><a href="/programs/index">Program</a>
                           </li>
                           <li class="breadcrumb-item active">Edit Program
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
		 
           
            {this.state.school_list.map((list) => (
			<div class="col s12 m12 ex-padd">   
            <div class="container view-Profile viewprograms view-Profile-mobile">
			   <div class="col s12 m12 mb-20 card-content iq-card">
                  <section class="invoice-list-wrapper section food ">
					<div class="children mb-20 iq-card2 bg-color-1">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header="View Program" classname="as" key="1">
						<div class="bb d-flow">
						<div class="col m12 s12 no-padd">
						<div class="col m4  s12">
							<label>Program Name</label>
							<input type="text" name="name" id="name"  onChange={this.handleSizeChange}/>
						</div>
						<div class="col m4 s12">
							<label>Program Fee</label>
							<input type="text" name="fee" id="fee" onChange={this.handleSizeChange}  placeholder="Program Fees (INR)" />
						</div>
						<div class="col m4 s12">
							<label>Select</label>
							<Select name="type" onChange={this.changetype} defaultValue={list.fee_type}   >
										<Option value="Year">/Year</Option>
										<Option value="Month">/Month</Option>
										<Option value="Week">/Week</Option>
									</Select>
						</div>
						</div>
						<div class="col m12 s12 no-padd">
						<div class="col m12 s12 mt-20 mb-20">
							<h6>Days</h6>
								<div class="col m4 s6 mt-5 add-notice  edit_staff">
									<input type="checkbox"  value="Monday" name="days" id="Monday" onChange={this.onChangechecked}/>
									<label for="Monday" class="add-event-label">Monday </label> 
								</div>
								<div class="col m4 s6 mt-5 add-notice  edit_staff">
									<input type="checkbox"  value="Tuesday" name="days" id="Tuesday" onChange={this.onChangechecked}/>
									<label for="Tuesday" class="add-event-label">Tuesday </label> 
								</div>
								<div class="col m4 s6 mt-5 add-notice  edit_staff">
									<input type="checkbox"  value="Wednesday" name="days" id="Wednesday" onChange={this.onChangechecked}/>
									<label for="Wednesday" class="add-event-label">Wednesday </label> 
								</div>
								<div class="col m4 s6 mt-5 add-notice  edit_staff">
									<input type="checkbox"  value="Thursday" name="days" id="Thursday" onChange={this.onChangechecked}/>
									<label for="Thursday" class="add-event-label">Thursday </label> 
								</div>
								<div class="col m4 s6 mt-5 add-notice  edit_staff">
									<input type="checkbox"  value="Friday" name="days" id="Friday" onChange={this.onChangechecked}/>
									<label for="Friday" class="add-event-label">Friday </label> 
								</div>
								<div class="col m4 s6 mt-5 add-notice  edit_staff">
									<input type="checkbox"  value="Saturday" name="days" id="Saturday" onChange={this.onChangechecked}/>
									<label for="Saturday" class="add-event-label">Saturday </label> 
								</div>
								<div class="col m4 s6 mt-5 add-notice  edit_staff">
									<input type="checkbox"  value="Sunday" name="days" id="Sunday" onChange={this.onChangechecked}/>
									<label for="Sunday" class="add-event-label">Sunday </label> 
								</div>
						</div>
						</div>
						 
						</div>  
						<div class="col m12 s12 no-padd mt-20 mb-10">
							<div class="col m6 s12 mb-20">
							   <h6><b>Age Group</b></h6>
								<div class="col m2 s12">
									<p className="center promram-from"><b>From :</b></p>
								</div>
								<div class="col m5 s6">
									<label>Year</label>
									<Select name="age_from_year" defaultValue={list.age_from_year} onChange={this.change_age_from_year}>
										<Select.Option value="0">0</Select.Option>
										<Select.Option value="1">1</Select.Option>
										<Select.Option value="0">2</Select.Option>
										<Select.Option value="3">3</Select.Option>
										<Select.Option value="4">4</Select.Option>
										<Select.Option value="5">5</Select.Option>
										<Select.Option value="6">6</Select.Option>
										<Select.Option value="7">7</Select.Option>
										<Select.Option value="8">8</Select.Option>
										<Select.Option value="9">9</Select.Option>
										<Select.Option value="10">10</Select.Option>
										<Select.Option value="11">11</Select.Option>
										<Select.Option value="12">12</Select.Option>
										<Select.Option value="13">13</Select.Option>
										<Select.Option value="14">14</Select.Option>
										<Select.Option value="15">15</Select.Option>
										<Select.Option value="16">16</Select.Option>
										
									</Select>
								</div>
								<div class="col m5 s6">
									<label>Month</label>
									<Select name="age_from_month" defaultValue={list.age_from_month} onChange={this.change_age_from_month}>
										
										<Select.Option value="1">1</Select.Option>
										<Select.Option value="0">2</Select.Option>
										<Select.Option value="3">3</Select.Option>
										<Select.Option value="4">4</Select.Option>
										<Select.Option value="5">5</Select.Option>
										<Select.Option value="6">6</Select.Option>
										<Select.Option value="7">7</Select.Option>
										<Select.Option value="8">8</Select.Option>
										<Select.Option value="9">9</Select.Option>
										<Select.Option value="10">10</Select.Option>
										<Select.Option value="11">11</Select.Option>
										<Select.Option value="12">12</Select.Option>
										
										
									</Select>
								</div>
								<div class="col m2 mt-10 s12" >
									<p className="center promram-from"><b>To :</b></p>
								</div>
								<div class="col m5 mt-10 s6">
									<label>Year</label>
									<Select name="age_to_year" defaultValue={list.age_to_year} onChange={this.change_age_to_year}>
										<Select.Option value="0">0</Select.Option>
										<Select.Option value="1">1</Select.Option>
										<Select.Option value="0">2</Select.Option>
										<Select.Option value="3">3</Select.Option>
										<Select.Option value="4">4</Select.Option>
										<Select.Option value="5">5</Select.Option>
										<Select.Option value="6">6</Select.Option>
										<Select.Option value="7">7</Select.Option>
										<Select.Option value="8">8</Select.Option>
										<Select.Option value="9">9</Select.Option>
										<Select.Option value="10">10</Select.Option>
										<Select.Option value="11">11</Select.Option>
										<Select.Option value="12">12</Select.Option>
										<Select.Option value="13">13</Select.Option>
										<Select.Option value="14">14</Select.Option>
										<Select.Option value="15">15</Select.Option>
										<Select.Option value="16">16</Select.Option>
										
									</Select>
								</div>
								<div class="col m5 mt-10 s6">
									<label>Month</label>
									<Select name="age_to_month" defaultValue={list.age_to_month} onChange={this.change_age_to_month}>
										
										<Select.Option value="1">1</Select.Option>
										<Select.Option value="0">2</Select.Option>
										<Select.Option value="3">3</Select.Option>
										<Select.Option value="4">4</Select.Option>
										<Select.Option value="5">5</Select.Option>
										<Select.Option value="6">6</Select.Option>
										<Select.Option value="7">7</Select.Option>
										<Select.Option value="8">8</Select.Option>
										<Select.Option value="9">9</Select.Option>
										<Select.Option value="10">10</Select.Option>
										<Select.Option value="11">11</Select.Option>
										<Select.Option value="12">12</Select.Option>
										
										
									</Select>
								</div>
							</div>
							<div class="col m6 s12">
								<h6><b>Timing</b></h6>
								<div class="col m6 s6">
									<label class="d-block">From</label>
									<TimePicker use12Hours format="h:mm a" defaultValue={moment(list.timing_from, format)} name="timing_from" onChange={this.onChange_timing_from} />
								</div>
								<div class="col m6 s6">
									<label class="d-block">To</label>
									<TimePicker use12Hours format="h:mm a" defaultValue={moment(list.timing_to, format)} name="timing_to" onChange={this.onChange_timing_to} />
								</div>
							</div>
						</div>
						
						</Panel>
					  </Collapse>
					</div> 
					<div class="desktop-view">
						<div class=" children  bg-color-1 mb-20 iq-card2">
							 <Collapse defaultActiveKey={['1']} onChange={callback}>
								<Panel header="Staff" classname="as" key="1">
									<Button className="snd-btn" onClick={this.showModal}> Select</Button>
									
									 <div class="children bg-blue attendance">
									  <Checkbox.Group  name="class_id[]" >
										{this.state.selected_program.map((list) => (
											   <Checkbox value={list.id} id={`category_id_${list.id}`} defaultChecked={true} disabled><label class="w-m" for={list.id} >
											   <div class="center">{list.name} </div>
											   </label>
											   </Checkbox>
											))} 
										</Checkbox.Group>
									</div>											
										   
					  
									
									<Modal
									  title="Select Staff"
									  visible={this.state.Program}
									  onOk={this.handleOkProgram}
									  onCancel={this.handleCancelProgram}>
			
									
								  <div class="children bg-blue communication popup row">	  
									<div class="row">
										{this.state.program_list.map((list) => (
											<div class="col m3 s6 d-contents mob-d-block">
											   <Checkbox  
												name="class_id[]"
												value={list.id}
												id={list.id}
												checked={this.state.dcheckedBoxes.find((ch) => ch === list.id)}
												onChange={(e) => this.dhandleCheckbox(e, list.id)}
												>
												<label for={list.id} className="checked">
												   <div class="center">{list.name}</div>
												</label>
											   </Checkbox>
										   </div>
										))}   
									</div>											
								</div>	
									
									</Modal>
									
								</Panel>
							  </Collapse>
						</div> 
					

						<div class="children bg-blue communication mb-20 pb-20 iq-card2 bg-color-1">
						 <Collapse defaultActiveKey={['1']} onChange={callback}>
							<Panel header="Children" classname="as bg-color-1" key="1">						 
							  <Button className="snd-btn" onClick={this.showchildModal}> Select</Button>
							
							  <div class="children bg-blue attendance">							  
									 <Checkbox.Group  name="children_id[]" >									
										{this.state.selected_student_data.map((list) => (
										   <Checkbox value={list.id} id={list.first_name} defaultChecked={true} readonly><label class="w-m" for={list.first_name} >
										   <div class="center"><img src={person} class="atd-img" /> {list.first_name} {list.last_name}</div>
										   </label>
										   </Checkbox>
										))} 
									</Checkbox.Group>
								</div>			  
							  
							  <Modal
									  title="Select Child"
									  visible={this.state.child}
									  onOk={this.handleOk}
									  onCancel={this.handleCancel}
									  
									>
									  <div class="children bg-blue attendance">
															  
									<div class="row">
										{this.state.school_list_.map((list) => (
											<div class="col m3 s6 d-contents mob-d-block">
											   <Checkbox  
												name="checked_id[]"
												value={list.id}
												id={list.id}
												checked={this.state.checkedBoxes.find((ch) => ch === list.id)}
												onChange={(e) => this.handleCheckbox(e, list.id)}
												>
												<label for={list.id} className="checked">
												   <div class="center"><img src={person} class="atd-img" /> {list.first_name} {list.last_name}</div>
												</label>
											   </Checkbox>
										   </div>
										))}   
									</div>	   
										   
										
									</div>
									</Modal>
							  
							  
							  
							</Panel>
						  </Collapse>
						</div> 

					
					</div>
					
					<div class="mobile-view">
						<div class=" children  bg-color-1 mb-20 iq-card2 center multiple">
							 <Collapse defaultActiveKey={['1']} onChange={callback}>
								<Panel header="Programs" classname="as" key="1">
									<Button className="snd-btn" onClick={this.showDrawerClass}> Select Staff</Button>

									 <div class="children bg-blue attendance program">
									 
										{this.state.selected_program.map((list) => (
											<label for={list.id} >
											   <div class="center">{list.short_name} </div>
											</label>
											  
										))}
										
										{(() => {  
											if (this.state.selected_program.length =='0') {
											return (
														<p id="error" class="">No Staff Selected</p>
													)
												}
										})()}
										
									</div>

									<Drawer
									  title="Select Staff"
									  width="100%"
									  onClose={this.onCloseClass}
									  visible={this.state.mobile_class}
									  bodyStyle={{ paddingBottom: 80 }}
									  className="select-child"
									  
									>
										<div class="children bg-blue communication popup row class">
											 <Checkbox.Group  name="children_id[]" onChange={this.handleClickProgram}>
												{this.state.program_list.map((list) => (
													   <Checkbox value={list.id} id={`prog_${list.id}`}><label class="w-m" for={`prog_${list.id}`} >
													   <div class="center">{list.short_name} </div>
													   </label>
													   </Checkbox>
													))} 
											</Checkbox.Group>
											
											{(() => {  
											if (this.state.program_list.length =='0') {
											return (
														<p id="error" class="">No Staff Found</p>
													)
												}
										})()}	

										</div>
										<div className="fix-foter">
										 
										  <Button onClick={this.handleOkProgram} type="primary">
											Done
										  </Button>
										</div>
									</Drawer>

								</Panel>
							  </Collapse>
						</div>
						<div class="children bg-color-6 mb-20 iq-card2 center">
						 <Collapse defaultActiveKey={['1']} onChange={callback}>
							<Panel header="Children" classname="as" key="1">
							  <Button className="snd-btn" onClick={this.showDrawer} >Select Child</Button>

							  <div class="children bg-blue attendance class">
									  
										{this.state.selected_student_data.map((list) => (
										<label for={list.id} >
										   <div class="center"><img src={person} class="atd-img" /> {list.short_name} </div>
										</label>
										   
										))}
										
										{(() => {  
											if (this.state.selected_student_data.length =='0') {
											return (
														<p id="error" class="">No Children Selected</p>
													)
												}
										})()}
								</div>

							  <Drawer
								  title="Select Child"
								  width="100%"
								  onClose={this.onClose}
								  visible={this.state.mobile_child}
								  bodyStyle={{ paddingBottom: 80 }}
								  className="select-child"
								>
								
									
									
									<div class="children bg-blue attendance mt-10">
										  <Checkbox.Group  name="item_name[]" >
									
										{this.state.school_list_.map((list) => (
										   <Checkbox value={list.id} id={list.id} defaultChecked={false}  onChange={this.handleClick}><label for={list.id} >
										   <div class="center"><img src={person} class="atd-img" /> {list.first_name} {list.last_name}</div>
										   </label>
										   </Checkbox>
										))}   
										   
										   
										</Checkbox.Group>
									</div>
								
									<div className="fix-foter">
										 
										 <Button onClick={this.handleOk} type="primary">
											Done
										 </Button>
									</div>
								  
								</Drawer>



							</Panel>
						  </Collapse>
						</div>
						
					</div>
								   
	  <div class="col s12 m12 mb-20 mt-0 card-content iq-card">				
			
                  <section class="invoice-list-wrapper section food">
				  <div class="ms-report"> 
			  	  <h6 class="mb-0"><big>Student Reports:-</big></h6>
				      {this.state.reports_master_list.map((list) => ( 
					  <Checkbox.Group style={{ width: '100%' }} >
					   <div class=" children  bg-color-1 mb-0 iq-card2">
						 <Collapse defaultActiveKey={['1']} onChange={callback}>
							<Panel header={list.subject} classname="as" key="1">

									{list.questions.map((row) => (
										<div class="col m12 s12">										
										 <div class="m-check">
											<input type="checkbox" name="master_id"  value={row.id}  class="form-check-input"  id={`question_${row.id}`} />
											<label class="form-check-label" for={`question_${row.id}`}>{row.question}</label>
										  </div>
										 </div>
												 
									 ))}	
										 
									{(() => {  
									if (list.questions.length =='0') {
									return (
									   <p id="error" class="">No Questions Found!</p>
									 )
									}
								})()}	
									
							</Panel>
						  </Collapse>
						</div> 
  </Checkbox.Group>
				  		))}
						
						
								{(() => {  
											if (this.state.reports_master_list.length =='0') {
											return (
														<p id="error" class="">No Data Found</p>
													)
												}
										})()}	
				
					</div>
					
			
					
				
					
			
                  </section>
               </div>		
						
					
					<div class="col m12 s12 meal mt-20 mb-20 pt-20 bt center">
						  <Button className="cancel-btn large-btn"  onClick={this.goBack}>Back</Button>
						 <Button className="snd-btn large-btn" onClick={this.handleSubmit} loading={this.state.loading}>Save</Button>
					</div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
			
			))}
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;


